import Swiper, { Navigation } from 'swiper';

export default function swipers() {

    new Swiper('.js-feedback-swiper', {
        modules: [Navigation],
        slidesPerView: 'auto',
        spaceBetween: 0,
        enabled: true,
        breakpoints: {
            769: {
                enabled: false,
            }
        },
        navigation: {
            nextEl: '.feedback__swiper-nav-next',
            prevEl: '.feedback__swiper-nav-prev',
        },
    });
}